export const onlyUniqueBy =
  (field: any) => (value: any, index: any, array: any) => {
    return (
      array.findIndex((entry: any) => entry[field] === value[field]) === index
    );
  };

export const sortByOrder = (a: any, b: any) => a.order - b.order;
